// The blocks of a support answer's light Markdown (Markdown.tsx draws them): paragraphs, "-" lists, "1." steps,
// and a heading line, should the model write one (shown as a bold line).

export interface Block {
  kind: 'p' | 'ul' | 'ol' | 'h';
  lines: string[];
  /** The first step's number, for "ol". */
  start?: number;
}

export function parseBlocks(text: string): Block[] {
  const blocks: Block[] = [];
  let current: Block | undefined;
  for (const raw of text.split('\n')) {
    const line = raw.trimEnd();
    if (!line.trim()) {
      current = undefined;
      continue;
    }
    const heading = /^\s*#{1,6}\s+(.*)$/.exec(line);
    if (heading) {
      blocks.push({ kind: 'h', lines: [heading[1]!] });
      current = undefined;
      continue;
    }
    const bullet = /^\s*[-*•]\s+(.*)$/.exec(line);
    const step = /^\s*(\d+)[.)]\s+(.*)$/.exec(line);
    const kind = bullet ? 'ul' : step ? 'ol' : 'p';
    const content = bullet?.[1] ?? step?.[2] ?? line.trim();
    if (current?.kind === kind) {
      current.lines.push(content);
    } else {
      current = { kind, lines: [content], start: step ? Number(step[1]) : undefined };
      blocks.push(current);
    }
  }
  return blocks;
}
